// extracted by mini-css-extract-plugin
export default {"root":"IconQuestionAnswer_root__0Rz1F"};